function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  margin-right: 0.25rem;\n  font-size: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  width: ", ";\n  height: ", ";\n  background-position: center;\n  background-repeat: no-repeat;\n  background-image: ", ";\n  transition: transform 0.2s;\n  transform: rotate(", ");\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  padding: 0.75rem 0;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  flex: 1 1 auto;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  text-transform: uppercase;\n  font-size: ", ";\n  border-bottom-style: solid;\n  border-bottom-width: ", ";\n  border-bottom-color: ", ";\n  height: 2rem;\n  cursor: pointer;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import React from 'react';
import styled from "../../theme";
export var SectionWrapper = styled.div(_templateObject(), function (props) {
  return props.theme.variables.colors.black;
});
export var SectionHeader = styled.div(_templateObject2(), function (props) {
  return props.theme.variables.fonts.size.smaller1;
}, function (props) {
  return props.theme.variables.borders.width.base;
}, function (props) {
  return props.theme.variables.colors.platinum;
});
export var SectionHeaderText = styled.div(_templateObject3());
export var SectionContent = styled.div(_templateObject4());

var WrappedDiv = function WrappedDiv(_ref) {
  var expanded = _ref.expanded,
      rest = _objectWithoutProperties(_ref, ["expanded"]);

  return React.createElement('div', rest);
};

export var SectionIcon = styled(WrappedDiv)(_templateObject5(), function (props) {
  return props.theme.variables.icons.size.medium;
}, function (props) {
  return props.theme.variables.icons.size.medium;
}, function (p) {
  return "url(\"".concat(p.theme.variables.icons.svg.chevronM, "\")");
}, function (props) {
  return props.expanded ? '-180deg' : '0deg';
});
export var SectionInfo = styled.div(_templateObject6(), function (props) {
  return props.theme.variables.fonts.size.smaller1;
});